import React from "react";
import AppBar from "../components/AppBar";
import EnvHeader from "../components/Env/Env.Header";
import EnvVersionFooter from "../components/Env/Env.Version.Footer";

interface LandingOptions {
  children: React.ComponentType | any;
}

const Default = ({ children }: LandingOptions) => (
  <React.Fragment>
    <EnvHeader />

    <AppBar />

    {children}

    <EnvVersionFooter />
  </React.Fragment>
);

export default Default;
